<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="800px">
    <div style="height: 400px; margin: 20px 60px 0 60px" :style="{'padding-left': readOnly ? '20px' : 0}">
      <el-form label-position="right" label-width="100px" :model="organ" :rules="rules" ref="organ"
               :key="pattern + organ.type">
        <div style="display: flex">
          <div style="width: 0; flex-grow: 1;">
            <input-form-item label="机构代码" prop="exposedCode"></input-form-item>

            <remote-form-item v-if="isShop" label="经营品牌" prop="carBandIds" class-name="Brand"></remote-form-item>

            <remote-form-item v-if="isWorkshop" label="派工方式" prop="dispatchPattern" class-name="DispatchPattern">
            </remote-form-item>

            <input-form-item label="联系人" prop="contactName"></input-form-item>

            <form-item label="地址" prop="addressCode" :show-value="organ.address">
              <el-area-cascader :props="{ checkStrictly: false }"
                                v-model="organ.addressCode" @change="changeAddress"
                                class="fullwidth"></el-area-cascader>
            </form-item>
            <div class="image">
              <el-form-item label="机构图片">
                <el-upload
                  accept="image/png, image/jpeg"
                  :show-file-list="false"
                  :action="$baseUrl + 'api/uploadImage'"
                  :on-success="uploadAvatarSuccess"
                  :on-error="uploadAvatarFailed"
                  :before-upload="beforeAvatarUpload">
                  <el-avatar shape="square" :size="70" :src="organ.imageUrl" style="margin-top: 8px"></el-avatar>
                </el-upload>
              </el-form-item>
            </div>
          </div>
          <div style="width: 0; flex-grow: 1">
            <input-form-item label="机构名称" prop="name"></input-form-item>

            <remote-form-item v-if="isShop" label="保险公司" prop="insuranceCompanyIds" class-name="INSURANCE_COMPANY">
            </remote-form-item>
            <div v-if="isWorkshop" style="height: 32px; line-height: 32px; margin-bottom: 18px" class="dispatch">
              <label style="margin-left: 32px; margin-right: 10px">钣金</label>
              <el-radio-group v-if="isEdit" v-model="organ.sheetMetalDispatch2Team">
                <el-radio :label="false">人</el-radio>
                <el-radio :label="true">组</el-radio>
              </el-radio-group>
              <label v-else class="value">{{organ.sheetMetalDispatch2Team ? '组' : '人'}}</label>
              <label style="margin-left: 32px; margin-right: 10px">喷漆</label>
              <el-radio-group v-if="isEdit" v-model="organ.paintDispatch2Team">
                <el-radio :label="false">人</el-radio>
                <el-radio :label="true">组</el-radio>
              </el-radio-group>
              <label v-else class="value">{{organ.paintDispatch2Team ? '组' : '人'}}</label>
            </div>

            <input-form-item label="联系电话" prop="cellphone"></input-form-item>
            <input-form-item label="地址详情" prop="addressDetail"></input-form-item>

            <remote-form-item :read-only="!isNew" v-if="isShop" label="所属车间" prop="workshopCode"
                              class-name="Workshop"></remote-form-item>

            <status-form-item label="状态"></status-form-item>
            <div v-if="isWorkshop" style="display: flex;align-items: center;">
              <label style="width:100px;">工单全部显示</label>
              <el-radio-group v-if="isEdit" v-model="organ.viewAll">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0" style="margin-right: 10px;">禁用</el-radio>
              </el-radio-group>
              <label v-else class="value">{{organ.viewAll ? '启用' : '禁用'}}</label>
            </div>
          </div>
        </div>

        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import { shareDataMixin } from '@/views/mixins/ShareData'
  import InputFormItem from '@/components/form/InputFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import FormItem from '@/components/form/FormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'

  export default {
    name: 'EditOrganDialog',
    mixins: [shareDataMixin],
    components: {
      TextareaFormItem,
      StatusFormItem,
      FormItem,
      RemoteFormItem,
      InputFormItem
    },
    props: {
      organ: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入名称',
              trigger: 'blur'
            }
          ],
          exposedCode: [
            {
              required: true,
              message: '请输入机构代码',
              trigger: 'blur'
            }
          ],
          carBandIds: [
            {
              required: true,
              message: '请选择品牌',
              trigger: 'change'
            }
          ],
          insuranceCompanyIds: [
            {
              required: true,
              message: '请选择保险公司',
              trigger: 'change'
            }
          ],
          dispatchPattern: [
            {
              required: true,
              message: '请选派工方式',
              trigger: 'change'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        if (this.isEdit) {
          this.$refs.organ.resetFields()
        }
      },
      add () {
        this.$refs.organ.validate(valid => {
          if (!valid) return

          this.$store.dispatch('organ/add', this.organ).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.organ.validate(valid => {
          if (!valid) return

          this.$store.dispatch('organ/updateOne', this.organ).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      },
      changeAddress (code, ary) {
        this.organ.address = ary.map(item => item.label).join('/')
      },
      uploadAvatarSuccess (res, file) {
        // if (res.data) {
        // this.user.avatarUrl = URL.createObjectURL(file.raw)
        // this.user.avatarUrl = res.data
        // }

        const reader = new FileReader()
        reader.readAsDataURL(file.raw)
        const organ = this.organ
        reader.onload = function (e) {
          organ.imageUrl = this.result
        }
      },
      uploadAvatarFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeAvatarUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isLt2M
      }
    },
    computed: {
      isNew () {
        return !this.organ.id
      },
      isEdit () {
        return !this.controlReadOnly
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增门店'
        if (this.isShop) {
          return this.readOnly ? '查看门店信息' : '编辑门店信息'
        } else if (this.isWorkshop) {
          return this.readOnly ? '查看车间信息' : '编辑车间信息'
        } else {
          return this.readOnly ? '查看集团信息' : '编辑集团信息'
        }
      },
      isShop () {
        if (this.isNew) return true
        return this.organ.type === 'SHOP'
      },
      isWorkshop () {
        if (this.isNew) return false
        return this.organ.type === 'WORKSHOP'
      },
      pattern () {
        if (this.isNew) return 'NEW'
        if (this.readOnly) return 'READ'
        return 'EDIT'
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*.el-radio:last-child*/
  /deep/ .dispatch {
    .el-radio {
      margin-right: 2px;
    }

    .el-radio__label {
      padding-left: 4px;
    }
  }

  /deep/ .image {
    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
    }
  }
</style>
